var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWhiteCloseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.9998 6.00372C17.8123 5.81625 17.558 5.71094 17.2928 5.71094C17.0277 5.71094 16.7733 5.81625 16.5858 6.00372L11.9998 10.5897L7.41382 6.00372C7.22629 5.81625 6.97198 5.71094 6.70682 5.71094C6.44165 5.71094 6.18735 5.81625 5.99982 6.00372C5.81235 6.19125 5.70703 6.44556 5.70703 6.71072C5.70703 6.97589 5.81235 7.2302 5.99982 7.41772L10.5858 12.0037L5.99982 16.5897C5.81235 16.7773 5.70703 17.0316 5.70703 17.2967C5.70703 17.5619 5.81235 17.8162 5.99982 18.0037C6.18735 18.1912 6.44165 18.2965 6.70682 18.2965C6.97198 18.2965 7.22629 18.1912 7.41382 18.0037L11.9998 13.4177L16.5858 18.0037C16.7733 18.1912 17.0277 18.2965 17.2928 18.2965C17.558 18.2965 17.8123 18.1912 17.9998 18.0037C18.1873 17.8162 18.2926 17.5619 18.2926 17.2967C18.2926 17.0316 18.1873 16.7773 17.9998 16.5897L13.4138 12.0037L17.9998 7.41772C18.1873 7.2302 18.2926 6.97589 18.2926 6.71072C18.2926 6.44556 18.1873 6.19125 17.9998 6.00372Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhiteCloseIcon);
export default __webpack_public_path__ + "static/media/white_close_icon.218fff07be9bd50c9824852371a59263.svg";
export { ForwardRef as ReactComponent };